import React, { useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Col, message, Row, Table } from 'antd';
import { parse } from 'qs';
import dayjs from 'utils/day';
import { getStudent, getStudentHistory } from 'requests/student';

const StudentView = () => {
    const [loading, setLoading] = useState(false);
    const [student, setStudent] = useState();
    const [writingHistory, setWritingHistory] = useState();
    const [readingHistory, setReadingHistory] = useState();
    const [currentQuery, setCurrentQuery] = useState({
        pageWriting: 1,
        pageSizeWriting: 10,
        pageReading: 1,
        pageSizeReading: 10,
    });

    const params = useParams();
    const location = useLocation();
    const { t } = useTranslation();

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        getHistory();
    }, [currentQuery]);

    const getData = async () => {
        try {
            setLoading(true);
            const result = await getStudent(params.id);
            setStudent(result);
        } catch (err) {
            console.log(err);
            message.error(t(err.response?.data.message || 'error'));
        } finally {
            setLoading(false);
        }
    };

    const getHistory = () => {
        const queryString = location.search.slice(1);
        const query = parse(queryString);

        const pageWriting = query.page || currentQuery.pageWriting;
        const takeWriting = query.pageSize || currentQuery.pageSizeWriting;
        const skipWriting = (pageWriting - 1) * takeWriting;

        getStudentHistory(params.id, 'writing', { take: takeWriting, skip: skipWriting })
            .then((data) => setWritingHistory(data))
            .catch((err) => {
                console.log(err);
                message.error(err.response?.data.message);
            });

        const pageReading = query.page || currentQuery.pageReading;
        const takeReading = query.pageSize || currentQuery.pageSizeReading;
        const skipReading = (pageReading - 1) * takeReading;

        getStudentHistory(params.id, 'reading', { take: takeReading, skip: skipReading })
            .then((data) => setReadingHistory(data))
            .catch((err) => {
                console.log(err);
                message.error(err.response?.data.message);
            });
    };

    const handlePageChangeWriting = (pageWriting, pageSizeWriting) => {
        const query = {
            ...currentQuery,
            pageWriting,
            pageSizeWriting,
        };

        setCurrentQuery(query);
    };

    const handlePageChangeReading = (pageReading, pageSizeReading) => {
        const query = {
            ...currentQuery,
            pageReading,
            pageSizeReading,
        };

        setCurrentQuery(query);
    };

    const writingColumns = [
        {
            title: t('time'),
            dataIndex: 'createdAt',
            render: (time) => (
                <div style={{ textAlign: 'center', width: 'fit-content' }}>
                    <div className="nowrap">{dayjs(time).format('YYYY-MM-DD')}</div>
                    <div className="nowrap">{dayjs(time).format('HH:mm')}</div>
                </div>
            ),
        },
        {
            title: t('writing_result_photo'),
            dataIndex: 'imagesUrl',
            render: (images) => {
                return (
                    <div className="result-images">
                        {images?.map((image, index) => (
                            <img key={index} src={image} alt="" />
                        ))}
                    </div>
                );
            },
        },
    ];

    const readingColumns = [
        {
            title: t('time'),
            dataIndex: 'createdAt',
            render: (time) => (
                <div style={{ textAlign: 'center', width: 'fit-content' }}>
                    <div className="nowrap">{dayjs(time).format('YYYY-MM-DD')}</div>
                    <div className="nowrap">{dayjs(time).format('HH:mm')}</div>
                </div>
            ),
        },
        {
            title: t('reading_result_photo'),
            dataIndex: 'imagesUrl',
            render: (images) => {
                return (
                    <div className="result-images">
                        {images?.map((image, index) => (
                            <img key={index} src={image} alt="" />
                        ))}
                    </div>
                );
            },
        },
    ];

    if (student && writingHistory && readingHistory) {
        return (
            <div className="add-teacher-content">
                <div className="teacher-btn">
                    {/* <a className="ant-btn print-btn">{t('print')}</a>
                    <a className="ant-btn download-btn">
                        <img src={download} alt="" />
                        {t('download')}
                    </a> */}
                </div>

                <div className="add-edit-form">
                    <h1 className="mt-32 mb-40" style={{ textAlign: 'center' }}>
                        ABK COLLEGE
                    </h1>
                    <div className="text">
                        <Row style={{ paddingLeft: '8%' }}>
                            <Col span={24} xl={12}>
                                <Row>
                                    <Col span={6}>
                                        <p>{t('student_name')}</p>
                                    </Col>
                                    <Col span={12}>
                                        <p>{student.name}</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={6}>
                                        <p>{t('nickname')}</p>
                                    </Col>
                                    <Col span={12}>
                                        <p>{student.nickname}</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={6}>
                                        <p>{t('birthday')}</p>
                                    </Col>
                                    <Col span={12}>
                                        <p>{student.birthday}</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={6}>
                                        <p>{t('class')}</p>
                                    </Col>
                                    <Col span={12}>
                                        <p>{student.classes?.map((_class) => _class.className).join(', ')}</p>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24} xl={12}>
                                <Row>
                                    <Col span={6}>
                                        <p>{t('nationality')}</p>
                                    </Col>
                                    <Col span={12}>
                                        <p>{student.nationality}</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={6}>
                                        <p>{t('email')}</p>
                                    </Col>
                                    <Col span={12}>
                                        <p>{student.email}</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={6}>
                                        <p>{t('mobile')}</p>
                                    </Col>
                                    <Col span={12}>
                                        <p>{student.mobile}</p>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </div>

                <Row className="history mt-24" gutter={[16, 16]}>
                    <Col sm={24} md={12} lg={12} xl={10}>
                        <Table
                            rowKey="id"
                            columns={writingColumns}
                            dataSource={writingHistory.records}
                            loading={loading}
                            pagination={{
                                size: 'small',
                                pageSize: currentQuery.pageSize,
                                total: writingHistory.total,
                                showSizeChanger: true,
                                showQuickJumper: true,
                                current: currentQuery.page,
                                onChange: handlePageChangeWriting,
                            }}
                        />
                    </Col>
                    <Col sm={24} md={12} lg={12} xl={14}>
                        <Table
                            rowKey="id"
                            columns={readingColumns}
                            dataSource={readingHistory.records}
                            loading={loading}
                            pagination={{
                                size: 'small',
                                pageSize: currentQuery.pageSize,
                                total: readingHistory.total,
                                showSizeChanger: true,
                                showQuickJumper: true,
                                current: currentQuery.page,
                                onChange: handlePageChangeReading,
                            }}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
};

export default StudentView;
